import { DefaultResponse } from './../../models/form/DefaultResponse';
import { BackendService } from './../../services/backend/backend.service';
import { IApiQueryListResponse } from './../../interfaces/api/api-query-list-response/api-query-list-response.interface';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { exhaustMap, share, map, catchError} from 'rxjs/operators';
import { InstitutionalAccountsActions } from './institutional-accounts.actions';

@Injectable()
export class InstitutionalAccountsEffects {

    /**
     * Recupera a lista de contas para depósito na Toro
     */
    getAccounts$ = createEffect(() => this.actions$
        .pipe(
			ofType(InstitutionalAccountsActions.getItems),
        exhaustMap((accounts) => {
            return this.backendService
                .get<DefaultResponse>('finance/transferaccount')
                .pipe(
                map((result) => {
                    if (result.ok) {
                        return {
                            type: InstitutionalAccountsActions.getItemsSuccess,
                            payload: result.value,
                        };
                    }

                    return {
                        type: InstitutionalAccountsActions.getItemsError,
                        payload: result.messages,
                    };
                }),
                catchError((error) => {
                    return of({
                        type: InstitutionalAccountsActions.getItemsError,
                        payload: error,
                    });
                }));
        }),
        share()));

    constructor(
        private actions$: Actions,
        private backendService: BackendService,
    ) { }
}
